import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { showErrorToast } from "@/utils/toastUtils";
import { useAuth } from "@/context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user, isLoading } = useAuth()
  const isCheckingAuth = Boolean(isLoading || user?.isLoading)
  const isAuthenticated = Boolean(user?.isAuthenticated)

  useEffect(() => {
    if (isCheckingAuth || isAuthenticated) return
    showErrorToast("로그인 후 이용해주세요.");
  }, [isCheckingAuth, isAuthenticated])

  if (isCheckingAuth) {
    return (
      <div className="route-auth-loading" aria-live="polite">
        인증 확인 중입니다.
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
